import { CATEGORY_ENUM } from 'enums/products/CategoryEnum'

export const MODULO_OR_INVERSOR = [CATEGORY_ENUM.INVERSOR, CATEGORY_ENUM.MODULO]
